var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.3;}\r\n\t.st1{opacity:0.3;fill:#FF3E4C;enable-background:new    ;}\r\n\t.st2{fill:#FF3E4C;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.64,108.6c-11.39-0.01-22.31-4.54-30.37-12.59c-8.06-8.05-12.59-18.97-12.61-30.36V6H103.74 C88.87,6,74.61,11.91,64.1,22.42C53.58,32.93,47.68,47.19,47.68,62.06V400c0,14.87,5.91,29.13,16.42,39.64 c10.51,10.51,24.77,16.42,39.64,16.42h230.41c14.87,0,29.13-5.91,39.64-16.42c10.51-10.51,16.42-24.77,16.42-39.64V108.6H338.64z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M390.2,108.6h-51.56c-11.39-0.01-22.31-4.54-30.37-12.59c-8.06-8.05-12.59-18.97-12.61-30.36V6L390.2,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.73,320.22H104.65c-2-0.1-3.88-0.97-5.26-2.42c-1.38-1.45-2.15-3.38-2.15-5.38c0-2,0.77-3.93,2.15-5.38 c1.38-1.45,3.26-2.32,5.26-2.42h215.07c1.06-0.05,2.12,0.11,3.11,0.47c0.99,0.37,1.9,0.93,2.67,1.66c0.77,0.73,1.38,1.61,1.8,2.58 c0.42,0.97,0.64,2.02,0.64,3.08c0,1.06-0.22,2.11-0.64,3.08c-0.42,0.97-1.03,1.85-1.8,2.58c-0.77,0.73-1.68,1.3-2.67,1.66 C321.84,320.11,320.78,320.27,319.73,320.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.73,232.24H104.65c-2-0.1-3.88-0.97-5.26-2.42c-1.38-1.45-2.15-3.38-2.15-5.38s0.77-3.93,2.15-5.38 c1.38-1.45,3.26-2.32,5.26-2.42h215.07c1.06-0.05,2.12,0.11,3.11,0.47c0.99,0.37,1.9,0.93,2.67,1.66c0.77,0.73,1.38,1.61,1.8,2.58 c0.42,0.97,0.64,2.02,0.64,3.08s-0.22,2.11-0.64,3.08c-0.42,0.97-1.03,1.85-1.8,2.58c-0.77,0.73-1.68,1.3-2.67,1.66 C321.84,232.13,320.78,232.29,319.73,232.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.73,276.24H104.65c-2-0.1-3.88-0.97-5.26-2.42c-1.38-1.45-2.15-3.38-2.15-5.38s0.77-3.93,2.15-5.38 c1.38-1.45,3.26-2.32,5.26-2.42h215.07c1.06-0.05,2.12,0.11,3.11,0.47c0.99,0.37,1.9,0.93,2.67,1.66c0.77,0.73,1.38,1.61,1.8,2.58 c0.42,0.97,0.64,2.02,0.64,3.08s-0.22,2.11-0.64,3.08c-0.42,0.97-1.03,1.85-1.8,2.58c-0.77,0.73-1.68,1.3-2.67,1.66 C321.84,276.13,320.78,276.29,319.73,276.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.9,188.24H104.65c-2-0.1-3.88-0.97-5.26-2.42c-1.38-1.45-2.15-3.38-2.15-5.38c0-2,0.77-3.93,2.15-5.38 c1.38-1.45,3.26-2.32,5.26-2.42H234.9c2,0.1,3.88,0.97,5.26,2.42c1.38,1.45,2.15,3.38,2.15,5.38c0,2-0.77,3.93-2.15,5.38 C238.78,187.27,236.9,188.14,234.9,188.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.9,144.24H104.65c-2-0.1-3.88-0.97-5.26-2.42c-1.38-1.45-2.15-3.38-2.15-5.38c0-2,0.77-3.93,2.15-5.38 c1.38-1.45,3.26-2.32,5.26-2.42H234.9c2,0.1,3.88,0.97,5.26,2.42c1.38,1.45,2.15,3.38,2.15,5.38c0,2-0.77,3.93-2.15,5.38 C238.78,143.27,236.9,144.14,234.9,144.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M430.87,361.42H170.38c-18.48,0-33.46,14.98-33.46,33.46v77.66c0,18.48,14.98,33.46,33.46,33.46h260.49 c18.48,0,33.46-14.98,33.46-33.46v-77.66C464.32,376.4,449.35,361.42,430.87,361.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M315.91,128.64h-36.83c-6.42,0-11.62,5.2-11.62,11.62v36.83c0,6.42,5.2,11.62,11.62,11.62h36.83 c6.42,0,11.62-5.2,11.62-11.62v-36.83C327.54,133.85,322.33,128.64,315.91,128.64z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M222.08,458.11h10.6v10.6h-10.6V458.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.87,398.71h16.2c5.47,0,9.56,1.47,12.3,4.4c2.73,2.93,4.1,7.23,4.1,12.9v6.9c0,5.67-1.37,9.97-4.1,12.9 c-2.73,2.93-6.83,4.4-12.3,4.4h-5.2v28.5h-11V398.71z M267.08,430.21c1.8,0,3.15-0.5,4.05-1.5s1.35-2.7,1.35-5.1v-8.3 c0-2.4-0.45-4.1-1.35-5.1c-0.9-1-2.25-1.5-4.05-1.5h-5.2v21.5H267.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M299.47,398.71h16.8c5.46,0,9.56,1.47,12.3,4.4c2.73,2.93,4.1,7.23,4.1,12.9v35.4c0,5.67-1.37,9.97-4.1,12.9 c-2.73,2.93-6.83,4.4-12.3,4.4h-16.8V398.71z M316.07,458.71c1.8,0,3.18-0.53,4.15-1.6c0.97-1.07,1.45-2.8,1.45-5.2v-36.4 c0-2.4-0.48-4.13-1.45-5.2c-0.97-1.07-2.35-1.6-4.15-1.6h-5.6v50H316.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M350.07,398.71h29.1v10h-18.1v19.5h14.2v10h-14.2v30.5h-11V398.71z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.77a7039a0d0a36a5136f1c1f1ec78fc9.svg";
export { ForwardRef as ReactComponent };